import React, { createContext, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

interface GuestContextType {
  songsPlayed: number;
  incrementSongsPlayed: () => void;
  resetSongsPlayed: () => void;
  checkGuestAccess: () => boolean;
}

const GuestContext = createContext<GuestContextType | undefined>(undefined);

const GUEST_SONG_LIMIT = 3;

export const GuestProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [songsPlayed, setSongsPlayed] = useState(0);
  const navigate = useNavigate();

  const incrementSongsPlayed = () => {
    const newCount = songsPlayed + 1;
    setSongsPlayed(newCount);
    
    if (newCount === GUEST_SONG_LIMIT) {
      toast.info(
        <div>
          <p className="font-medium mb-2">Ready to keep listening?</p>
          <p className="text-sm">Sign up for free or try Vision Music UNLIMITED!</p>
        </div>,
        {
          duration: 10000,
          action: {
            label: 'Sign Up',
            onClick: () => navigate('/signup'),
          },
        }
      );
    }
  };

  const resetSongsPlayed = () => {
    setSongsPlayed(0);
  };

  const checkGuestAccess = () => {
    return songsPlayed < GUEST_SONG_LIMIT;
  };

  return (
    <GuestContext.Provider value={{
      songsPlayed,
      incrementSongsPlayed,
      resetSongsPlayed,
      checkGuestAccess,
    }}>
      {children}
    </GuestContext.Provider>
  );
};

export const useGuest = () => {
  const context = useContext(GuestContext);
  if (context === undefined) {
    throw new Error('useGuest must be used within a GuestProvider');
  }
  return context;
};